module.exports = __webpack_public_path__ + "static/img/组 21.25d2e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/组 21.png
// module id = aH+f
// module chunks = 3